import { motion } from "framer-motion";
import { Target, Eye, HeartHandshake } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { imgUrl } from "../lib/api";

const DEFAULT_IMG =
  "https://images.unsplash.com/photo-1554344728-77cf90d9ed26?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxmaXRuZXNzJTIwYm9keWJ1aWxkZXIlMjB3b3Jrb3V0JTIwZ3ltJTIwdHJhaW5pbmd8ZW58MHx8fGJsYWNrfDE3OTMwMjE4Mjd8MA&ixlib=rb-4.1.0&q=85";

const ICONS = [Target, Eye, HeartHandshake];

export default function About() {
  const content = useContent();
  const a = content.about;
  const pillars = a.pillars || [];
  const img = content.about_image ? imgUrl(content.about_image) : DEFAULT_IMG;

  return (
    <section id="nosotros" className="relative overflow-hidden border-y border-[#E8E4D9] bg-ivory py-24 lg:py-32" data-testid="about-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
          >
            <p className="font-mono mb-4 text-xs uppercase tracking-[0.3em] text-brand">
              {a.overline}
            </p>
            <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-neutral-900 sm:text-3xl lg:text-4xl">
              {a.title}
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-neutral-500 sm:text-base">
              {a.text}
            </p>
            <div className="mt-8 space-y-4">
              {pillars.map((p, i) => {
                const Icon = ICONS[i % ICONS.length];
                return (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: -24 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.12, duration: 0.6 }}
                    className="flex gap-4 rounded-2xl border border-[#E8E4D9] bg-white p-5 shadow-sm"
                    data-testid={`about-pillar-${i}`}
                  >
                    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-light text-brand">
                      <Icon size={20} />
                    </div>
                    <div>
                      <h3 className="font-display text-base font-bold text-neutral-900">{p.title}</h3>
                      <p className="mt-1 text-sm leading-relaxed text-neutral-500">{p.desc}</p>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          >
            <div className="overflow-hidden rounded-3xl border border-[#E8E4D9] shadow-sm">
              <img src={img} alt="Landerlan Dominicana - Nosotros" className="aspect-[4/5] w-full object-cover lg:aspect-[3/4]" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
